import * as Cookie from "js-cookie";
import { Config } from "../../models/config";
import { AccountDetail } from "../../models/accounts/accountDetail";
import { DCCutoffCountResponse } from "../../models/csos/dcCutoffCountResponse";
import { OrdersUpdate } from "../../models/csos/ordersUpdate";
import { SummaryRequest } from "../../models/csos/summaryRequest";
import { SummaryResponse } from "../../models/csos/summaryResponse";
import { UpdateOrderResponse } from "../../models/csos/updateOrderResponse";
import { UpdateQuantity } from "../../models/csos/updateQuantity";
import { configService } from "../configService";
import { userService } from "../userService";
import { apiHelpers } from "./apiHelpers";
import { ApiResponse } from "./apiResponse";

const config: Config = configService.getConfig();

function getHeaders(): { [key: string]: string } {
  return {
    "x-api-key": config.apiKeyCSOS,
    "Authorization": Cookie.get("accessToken") || "",
  };
}

function getHeadersWithUserId(): { [key: string]: string } {
  return {
    ...getHeaders(),
    "userId": userService.getCurrentUser() || "",
  };
}

export const csosApiService = {
  getPendingOrders: (): Promise<ApiResponse<SummaryResponse>> => {
    return apiHelpers.get<SummaryResponse>(
      config.csosUrl,
      `/userid/${userService.getCurrentUser()}/orders`,
      config.csosPort,
      {fulfillmentOrderStatus: "Pending" },
      getHeaders(),
    );
  },

  fetchtOrdersData: (summaryRequest: SummaryRequest): Promise<ApiResponse<SummaryResponse>> => {
    const params: { [key: string]: string | number | boolean } = {};
    params["orderStatus"] = summaryRequest.status;
    if (summaryRequest.limit !== undefined) params["limit"] = summaryRequest.limit;
    if (summaryRequest.sort !== undefined) params["sort"] = summaryRequest.sort;
    if (summaryRequest.offset !== undefined) params["offset"] = summaryRequest.offset;

    return apiHelpers.get<SummaryResponse>(
      config.csosUrl,
      `/userid/${userService.getCurrentUser()}/orders`,
      config.csosPort,
      params,
      getHeaders(),
    );
  },

  getPendingOrder: (orderId: string, accounts: string): Promise<ApiResponse<SummaryResponse>> => {
    return apiHelpers.get<SummaryResponse>(
      config.csosUrl,
      `/userid/${userService.getCurrentUser()}/orders`,
      config.csosPort,
      { include: "items", account: accounts, orderId },
      getHeaders(),
    );
  },

  getNextOrder: (): Promise<ApiResponse<SummaryResponse>> => {
    return apiHelpers.get<SummaryResponse>(
      config.csosUrl,
      `/userid/${userService.getCurrentUser()}/orders`,
      config.csosPort,
      { include: "items", orderId: "all" },
      getHeaders(),
    );
  },

  updateCsosOrders: (ordersUpdate: OrdersUpdate): Promise<ApiResponse<UpdateOrderResponse>> => {
    return apiHelpers.put<OrdersUpdate, UpdateOrderResponse>(
      config.csosUrl,
      ordersUpdate,
      `/order`,
      config.csosPort,
      {},
      getHeadersWithUserId(),
    );
  },

  updateQuantity: (updateQuantity: UpdateQuantity): Promise<ApiResponse<any>> => {
    return apiHelpers.put<UpdateQuantity, any>(
      config.csosUrl,
      updateQuantity,
      `/orderitems`,
      config.csosPort,
      {},
      getHeadersWithUserId(),
    );
    
  },

  getDCCutoffData: (): Promise<ApiResponse<DCCutoffCountResponse>> => {
    return apiHelpers.get<DCCutoffCountResponse>(
      config.csosUrl,
      `/userid/${userService.getCurrentUser()}/dccutoffcounts`,
      config.csosPort,
      {},
      getHeaders(),
    );
  },

  getAccountsForUser: (): Promise<ApiResponse<Array<AccountDetail>>> => {
    return apiHelpers.get<Array<AccountDetail>>(
      config.csosUrl,
      `/userid/${userService.getCurrentUser()}/accounts`,
      config.csosPort,
      {},
      getHeaders(),
    );
  },

  getEncyrptedAccounts: (account: string): Promise<ApiResponse<string>> => {
    return apiHelpers.get<string>(
      config.csosUrl,
      `/v1/shipTo/${account}`,
      config.csosPort,
      {},
      getHeaders(),
    );
  },
};
